import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchMasterData } from '../../api/cafmApi'
import { MasterDataType } from '../../components/EditFieldMapping/OrganizationDetails'
import { RootState } from '../../../store/store'

// Async thunk to fetch users
export const fetchMasterDeatils = createAsyncThunk<Record<string, string>, { source_system: string; country?: string }, { rejectValue: string }>(
  'MasterData/fetchMasterDeatils',
  async ({ source_system, country }, { rejectWithValue }) => {
    try {
      console.log('MasterDataSlice - Received source_system:', source_system, 'country:', country)
      const response = await fetchMasterData(source_system!, country)
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const initialState: { MasterDetails: MasterDataType; loading: boolean; error: string | null } = {
  MasterDetails: {
    source_system: '',
    objectTypes: [],
  },
  loading: false,
  error: null,
}

const MasterDataSlice = createSlice({
  name: 'MasterData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMasterDeatils.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMasterDeatils.fulfilled, (state, action) => {
        state.loading = false
        state.MasterDetails = action.payload as unknown as MasterDataType
      })
      .addCase(fetchMasterDeatils.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

// Selector to get master data
export const selectMasterData = (state: RootState) => state.MasterData

export default MasterDataSlice.reducer
